<p>{{ settings.welcome }}</p>
<p>Please login</p>
<div *ngIf="environmentSettings.user">
  Local Env Hint:
  <pre>
    email   : {{ environmentSettings.user }}&#64;example.com
    password: {{ environmentSettings.localPassword }}
  </pre>
</div>
